/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: CrashGameLabel.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  14.06.23 2:05 pm.
 * Last modified: 14.06.23 2:05 pm.
 *
 * More information at: https://egt-digital.com/
 */

import React from 'react';
import { useTranslator } from '../../contexts/TranslatorContext';

const CrashGameLabel = () => {
    const translate = useTranslator();

    return (
        <div className={'egt_game_jackpot_bottom_band jackpot_game_label_crash_game'}>{translate('CRASH_GAME')}</div>
    );
};

export default CrashGameLabel;
